export const API_BASE_URLS = {
  BASE_URL: import.meta.env.VITE_BASE_API_URL,
  DATA_MANAGEMENT_API_URL: import.meta.env.VITE_DATA_MANAGEMENT_API_URL,
  CDFI_API_URL: import.meta.env.VITE_CDFI_API_URL,
};
